export class GuestCampaign
{
	testId: number;
	testDate: Date;
}
